import { SVGProps } from '@components/Icon/types';

export const Documents = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(4, 2)">
      <path
        d="M8.55808 14.4558C8.91132 14.4558 9.19766 14.7361 9.19782 15.0817C9.19782 15.4274 8.91142 15.7076 8.55808 15.7076H3.07441C2.72108 15.7075 2.43466 15.4274 2.43466 15.0817C2.43482 14.7361 2.72118 14.4558 3.07441 14.4558H8.55808Z"
        fill={fill}
      />
      <path
        d="M12.9456 11.7738C13.2989 11.7738 13.5853 12.054 13.5853 12.3997C13.5851 12.7452 13.2988 13.0255 12.9456 13.0256H3.07441C2.72118 13.0255 2.43482 12.7452 2.43466 12.3997C2.43466 12.054 2.72108 11.7738 3.07441 11.7738H12.9456Z"
        fill={fill}
      />
      <path
        d="M12.9456 9.09091C13.2989 9.09093 13.5853 9.37114 13.5853 9.7168C13.5853 10.0625 13.2989 10.3427 12.9456 10.3427H3.07441C2.72108 10.3427 2.43466 10.0625 2.43466 9.7168C2.43469 9.37114 2.7211 9.09093 3.07441 9.09091H12.9456Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.36116 0C9.91155 0 10.4403 0.213532 10.8294 0.594815L15.8258 5.48295C15.9089 5.56436 15.9653 5.66838 15.9882 5.78125C15.9923 5.80127 15.9981 5.89847 16 5.91886V17.4858C16 18.8684 14.8434 20 13.4301 20H2.56987C1.15663 20 0 18.8684 0 17.4858V2.5142C0 1.13158 1.15663 0 2.56987 0H9.36116ZM2.56987 1.16388C1.80209 1.16388 1.18966 1.76305 1.18966 2.5142V17.4858C1.18966 18.237 1.80209 18.8361 2.56987 18.8361H13.4301C14.1979 18.8361 14.8103 18.237 14.8103 17.4858V8.21822L14.8058 6.47639H11.4555C10.8493 6.47634 10.3007 6.21768 9.92015 5.80788C9.585 5.44683 9.38028 4.96848 9.38022 4.44602V1.17809L9.37205 1.17276L9.36842 1.17099C9.362 1.16713 9.35788 1.16498 9.35572 1.16388H2.56987ZM10.5699 4.44602C10.57 4.9305 10.9603 5.31241 11.4555 5.3125H13.9691L10.5699 1.98686V4.44602ZM0.101633 2.5506V2.54705L0 2.5142L0.101633 2.5506Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'documents';
